import { FormDefinition, FormElementType } from "~/api";
import { nonQuestionElements } from "~/NewFormBuilder/types/NonQuestionElements";

/**
 * Element types that don't capture an answer (layout / action elements). Used to filter to
 * "questions" in answer-oriented UIs (answer-move, the question matrix, version compare).
 * Aliased to the canonical {@link nonQuestionElements} so the two lists can't drift — that list
 * also excludes NAME_STAMP, LINKED_ANSWER, COMPLIANCE_ITEM and WORKFLOW_ASSOCIATION, which are
 * likewise not free-text questions.
 */
export const nonAnswerableTypes: FormElementType[] = nonQuestionElements;

/** Whether an element captures an answer (i.e. is a "question"). */
export function isQuestionElement(type: FormElementType): boolean {
  return !nonAnswerableTypes.includes(type);
}

export function getNewQuestionCode(
  form: FormDefinition,
  questionType: FormElementType,
): string {
  const codeNumber =
    form.components.filter((c) => c.type === questionType).length + 1;

  return `${questionType}${codeNumber}`;
}
